import React from 'react';
import { useGlobalContext } from '../../../store/global';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router';

const SubscribeHotel = (props) => {
  const { closeModal } = useGlobalContext();
  const { t } = useTranslation();
  const goToProfilePage = () => {
    closeModal();
    props.history.push("/profile/edit?from=modal");
  };

  return (
      <div className="popup-inner admin-msg" style={{ maxWidth: '650px' }}>
        <div className="popup-title">{t('admin_msg_modal_title')}</div>
        <div className="popup-content">
          <div className="popup-content--icon">
            <img src="/assets/images/alert.svg" alt="alert logo" />
          </div>
          <div className="popup-content--text">
            <h1 className="popup-content--text--title">{t("admin_msg_modal_hotel_not_subscribed_service")}</h1>
            <p className="popup-content--text--alert">{t("admin_msg_modal_contact_admin_to_enable_access")}</p>
          </div>
        </div>
        <div className="popup-actions">
          <div
            className="popup-actions--button popup-actions--button__confirm" 
            onClick={goToProfilePage}>
            {t("admin_msg_modal_go_to_my_profile")}
          </div>
        </div>  
    </div>
  );
}

export default withRouter(SubscribeHotel);